// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// Git Hub prod updateds.
//Dev Environment
export const environment = {
  production: false,
  stage : {
    appurl: 'https://mediapaystage.nbcuni.com',
    //idmurl: 'http://localhost:65164/api/',  
    idmurl: 'https://mediapayuserservicestage.nbcuni.com/api/', 
    MsauthUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/authorize',

    tokenUrl :'https://fss.stg.inbcu.com/fss/as/token.oauth2',
    ///authUrl: 'https://mediapay-auth.login.sysusz.nbcuni.com/',
     MsAuthclientId: 'd48bd17d-3684-4e96-ac28-5944316c8b2c',
    logoutUri: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/logout',
    url: 'https://mediapayuserservicestage.nbcuni.com/api/',  
    //Userservicebaseurl: 'https://mediapayuserservicedev.nbcuni.com', 
    Userservicebaseurl: 'https://mediapayuserservicestage.nbcuni.com', 
    Invoiceservicebaseurl: 'https://mediapayinvoiceservicestage.nbcuni.com', 
    ChangePasswordOnForgotPassword: '/ChangePasswordOnForgotPassword',
    Admin: '/Admin',
    Invoice: '/Invoice',
    RefundApprove: '/RefundApprove',
    //appurl: 'http://localhost:4200',
     //Userservicebaseurl: 'http://localhost:65164',
    // Invoiceservicebaseurl:'http://localhost:56375',
  }
  
  
};

